import type { TranscriptorConsultation } from '../config';

/**
 * Newest first by the displayed date. The server orders by started_at and
 * puts recordings without one last, so the list has to be re-sorted once the
 * created_at fallback is applied.
 */
export const sortConsultationsByDate = (
  consultations: TranscriptorConsultation[],
): TranscriptorConsultation[] =>
  [...consultations].sort((a, b) => b.date.getTime() - a.date.getTime());
